
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m12.9814 17.6932c.3729.3503.954.3503 1.3269-.0001l5.3336-5.011c.4189-.3935.4189-1.0588 0-1.4523l-5.3336-5.01108c-.3729-.35037-.954-.35039-1.3269-.00004-.4074.38273-.4074 1.02986.0001 1.41255l3.4735 3.26247h-11.41445c-.55027 0-.99636.4461-.99636.9963v.1275c0 .5503.44609.9964.99636.9964h11.41905l-3.4781 3.2667c-.4075.3827-.4075 1.0299-.0001 1.4126z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    